import script from "./DimensionChips.vue?vue&type=script&setup=true&lang=js"
export * from "./DimensionChips.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__